import MainRoute from "./route/MainRoute"
import React from "react"

function App() {
  return (
    <MainRoute />
  );
}

export default App;